import classNames from './styles.module.scss'


export default function Dots() {
  return (
    <div className={classNames.dot} />
  )
}
